import { AcTemplateProfileList } from '@components'

export const TemplateSideBarClientProfile = () => {
  return <AcTemplateProfileList />
}
